import React from 'react';
import { observer } from "mobx-react";
import uniqueId from 'lodash/uniqueId';
import { Icon } from 'components/Icon';
import { OnVoardLogo, OnVoardIcon } from 'components/Svg';
import MenuItem from '../Menu/MenuItem';
import AdminMenuGroup from '../Menu/AdminMenuGroup';
import EcommerceMenu from '../Menu/EcommerceMenu';
import { DataMenu } from '../Menu/AdminMenuGroup';
import consoleStore from 'stores/Console/ConsoleStore';
import constants from 'Constants';
import * as auth from 'Auth';
import * as paths from 'Paths';
import * as utils from 'Utils';
import './styles.scss';




@observer
class OverviewMenu extends React.Component {
  constructor (props) {
    super(props);
    this.overviewUrl = paths.getPathMarketingPlatformOverview();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.MARKETING_PLATFORM_MENU.OVERVIEW);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.OVERVIEW;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.MARKETING_PLATFORM_MENU.OVERVIEW}
        menuName="Overview"
        icon="home"
        href={this.overviewUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class AnalyticsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.analyticsUrl = paths.getPathMarketingPlatformAnalytics();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.MARKETING_PLATFORM_MENU.ANALYTICS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.ANALYTICS;
  };

  render() {
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.MARKETING_PLATFORM_MENU.ANALYTICS}
        menuName="Analytics"
        icon="bar-chart-square"
        href={this.analyticsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}


@observer
class ContactsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.contactsUrl = paths.getPathContacts();
    this.listsUrl = paths.getPathContactLists();
    this.tagsUrl = paths.getPathContactTags();
    this.segmentsUrl = paths.getPathContactSegments();
    this.activitiesUrl = paths.getPathOnVoardContactActivities();
    this.propertiesUrl = paths.getPathPredefinedContactProperties();
    this.bulkActionsUrl = paths.getPathContactsBulkActions();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.MARKETING_PLATFORM_MENU.CONTACTS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.CONTACTS,
        label: "Manage Contacts",
        href: this.contactsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.contactsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.CONTACTS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_LISTS,
        label: "Lists",
        href: this.listsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.listsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_LISTS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_TAGS,
        label: "Tags",
        href: this.tagsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.tagsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_TAGS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_SEGMENTS,
        label: "Segments",
        href: this.segmentsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.segmentsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_SEGMENTS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_ACTIVITIES,
        label: "Activities",
        href: this.activitiesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.activitiesUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_ACTIVITIES
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_PROPERTIES,
        label: "Properties",
        href: this.propertiesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.propertiesUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.CONTACT_PROPERTIES
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.CONTACTS_BULK_ACTIONS,
        label: "Bulk Actions",
        href: this.bulkActionsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.bulkActionsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.CONTACTS_BULK_ACTIONS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.MARKETING_PLATFORM_MENU.CONTACTS}
        menuName="Contacts"
        icon="id-card"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}


@observer
class EmailsMenu extends React.Component {
  constructor (props) {
    super(props);

    const qs = {};
    qs['theme'] = constants.PRODUCT_MARKETING_PLATFORM;

    this.emailsUrl = paths.getPathBroadcastEmails();
    this.broadcastsUrl = paths.getPathBroadcasts();
    this.templatesUrl = paths.getPathCustomEmailTemplates();
    this.tagsUrl = utils.appendQueryString(paths.getPathEmailTags(), qs);
    this.emailDomainsUrl = utils.appendQueryString(paths.getPathEmailDomains(), qs);
    this.emailProfilesUrl = utils.appendQueryString(paths.getPathEmailProfiles(), qs);
    this.emailSettingsUrl = utils.appendQueryString(paths.getPathEmailSettings(), qs);
    this.smtpProfilesUrl = utils.appendQueryString(paths.getPathSmtpProfiles(), qs);
    this.sendingRulesUrl = utils.appendQueryString(paths.getPathEmailSendingRules(), qs);
    this.deliveryStatsUrl = utils.appendQueryString(paths.getPathEmailDeliveryStats(), qs);
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.MARKETING_PLATFORM_MENU.EMAILS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.EMAILS,
        label: "Manage Emails",
        href: this.emailsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.EMAILS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_TEMPLATES,
        label: "Templates",
        href: this.templatesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.templatesUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_TEMPLATES
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.BROADCASTS,
        label: "Broadcasts",
        href: this.broadcastsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.broadcastsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.BROADCASTS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.TAGS,
        label: "Tags",
        href: this.tagsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.tagsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.TAGS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_PROFILES,
        label: "Email Profiles",
        href: this.emailProfilesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailProfilesUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_PROFILES
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_SETTINGS,
        label: "Email Settings",
        href: this.emailSettingsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.emailSettingsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_SETTINGS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.SMTP_PROFILES,
        label: "SMTP Profiles",
        href: this.smtpProfilesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.smtpProfilesUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.SMTP_PROFILES
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_SENDING_RULES,
        label: "Sending Rules",
        href: this.sendingRulesUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.sendingRulesUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_SENDING_RULES
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_DELIVERY_STATS,
        label: "Delivery Stats",
        href: this.deliveryStatsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.deliveryStatsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.EMAIL_DELIVERY_STATS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.MARKETING_PLATFORM_MENU.EMAILS}
        menuName="Emails"
        icon="mail-send"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}





@observer
class WorkflowsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.workflowsUrl = paths.getPathWorkflows();
    this.playbooksUrl = paths.getPathWorkflowPlaybooks();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.MARKETING_PLATFORM_MENU.WORKFLOWS);
    }
  }

  getSubMenus = () => {
    const { activeSidebar, history } = this.props;
    let subMenus = [{
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.WORKFLOWS,
        label: "Manage Workflows",
        href: this.workflowsUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.workflowsUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.WORKFLOWS
    }, {
        display: true,
        id: constants.MARKETING_PLATFORM_SIDEBAR.WORKFLOW_PLAYBOOKS,
        label: "Playbooks",
        href: this.playbooksUrl,
        onClick: (e) => utils.handleGoTo(e, history, this.playbooksUrl),
        isActive: activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.WORKFLOW_PLAYBOOKS
    }];

    return subMenus;
  };

  checkIsActive = () => {
    return this.getSubMenus().some((subMenu) => subMenu.isActive);
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = this.getSubMenus();

    return (
      <MenuItem
        menuId={constants.MARKETING_PLATFORM_MENU.WORKFLOWS}
        menuName="Workflows"
        icon="bot"
        subMenus={subMenus}
        isActive={this.checkIsActive()}
        {...this.props}
      />
    );
  }
}



@observer
class ConnectionsMenu extends React.Component {
  constructor (props) {
    super(props);
    this.connectionsUrl = paths.getPathMarketingPlatformConnections();
  }

  componentDidMount() {
    let isActive = this.checkIsActive();
    if (isActive) {
      this.props.updateActiveMenu(constants.MARKETING_PLATFORM_MENU.CONNECTIONS);
    }
  }

  checkIsActive = () => {
    const { activeSidebar } = this.props;
    return activeSidebar === constants.MARKETING_PLATFORM_SIDEBAR.CONNECTIONS;
  };

  render() {
    const { activeSidebar, history } = this.props;
    let subMenus = [];

    return (
      <MenuItem
        menuId={constants.MARKETING_PLATFORM_MENU.CONNECTIONS}
        menuName="Connections"
        icon="shape-circle"
        href={this.connectionsUrl}
        isActive={this.checkIsActive()}
        subMenus={subMenus}
        {...this.props}
      />
    );
  }
}






@observer
class MarketingPlatformSidebar extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      activeMenu: "",
    };
  }

  componentDidMount() {
    auth.setCurrentProduct(constants.PRODUCT_MARKETING_PLATFORM);
  }

  updateActiveMenu = (activeMenu) => {
    if (this.state.activeMenu === activeMenu) {
      this.setState({activeMenu: ""});
      return;
    }

    this.setState({activeMenu: activeMenu});
  };

  render() {
    return (
      <div className="sidebar sidebar-marketingplatform">
        <div className="sidebar-head">
          <div className="head-icon"><OnVoardIcon /></div>
          <div className="head-title">Marketing Platform</div>
        </div>

        <div className="menu-items">
          <div className="menu-group">
            <OverviewMenu
              isActive={this.state.activeMenu === constants.MARKETING_PLATFORM_MENU.OVERVIEW}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ContactsMenu
              isActive={this.state.activeMenu === constants.MARKETING_PLATFORM_MENU.CONTACTS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EmailsMenu
              isActive={this.state.activeMenu === constants.MARKETING_PLATFORM_MENU.EMAILS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <EcommerceMenu
              theme={constants.PRODUCT_MARKETING_PLATFORM}
              displayProducts={true}
              isActive={this.state.activeMenu === constants.MARKETING_PLATFORM_MENU.ECOMMERCE}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <WorkflowsMenu
              isActive={this.state.activeMenu === constants.MARKETING_PLATFORM_MENU.WORKFLOWS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <AnalyticsMenu
              isActive={this.state.activeMenu === constants.MARKETING_PLATFORM_MENU.ANALYTICS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <ConnectionsMenu
              isActive={this.state.activeMenu === constants.MARKETING_PLATFORM_MENU.CONNECTIONS}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />

            <DataMenu
              isActive={this.state.activeMenu === constants.MARKETING_PLATFORM_MENU.DATA}
              updateActiveMenu={this.updateActiveMenu}
              {...this.props}
            />
          </div>

          <AdminMenuGroup
            activeMenu={this.state.activeMenu}
            updateActiveMenu={this.updateActiveMenu}
            product={constants.PRODUCT_MARKETING_PLATFORM}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}



export { MarketingPlatformSidebar };

